import { createApp } from 'vue';
import App from './App.vue';

import router from './router';
import vuetify from './services/vuetify';
import i18n from './services/i18n';
import { store } from './store';
import './assets/style/style.scss';


const app = createApp(App);

app.use(router);
app.use(vuetify);
app.use(i18n);
app.use(store);

app.mount('#app');
